import { HStack } from '@cdl/heartbeat-react';
import { DateRangeFilter } from './DateRangeFilter';
import { GlobalFilter } from './GlobalFilter';

export const FiltersBar = () => {
  return (
    <HStack spacing='s'>
      <GlobalFilter />
      <DateRangeFilter />
    </HStack>
  );
};
